import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "position-relative w-100" };
const _hoisted_2 = { class: "d-flex gap-2 align-items-center" };
const _hoisted_3 = { class: "d-flex flex-grow-1 flex-column gap-2" };
const _hoisted_4 = { class: "fw-bold bagde-name mb-0" };
const _hoisted_5 = { class: "mb-0 bagde-description" };
const _hoisted_6 = { class: "image-wrapper h-100 d-flex p-2 rounded-3 align-items-center justify-content-center" };
const _hoisted_7 = ["src"];
import { redirectToUserProfile } from '@/utils/helpers';
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BadgeToast',
    setup(__props) {
        const store = useStore();
        const badgeData = computed(() => store.getters.getUserNewBadge);
        const userId = computed(() => store.getters.getId);
        const redirectToProfile = async () => {
            await resetNewBadgeState();
            redirectToUserProfile(userId?.value || null);
        };
        const initializeCloseTimer = () => {
            setTimeout(() => {
                resetNewBadgeState();
            }, 5000);
        };
        const resetNewBadgeState = () => {
            store.dispatch('setUserNewBadge');
        };
        onMounted(() => {
            initializeCloseTimer();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                onClick: redirectToProfile,
                class: "z-3 overflow-hidden cursor-pointer rounded-3 p-3 shadow toast-wrapper position-fixed d-flex flex-column gap-3"
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "mb-0 fw-bold text-center" }, "Nova conquista desbloqueada!", -1)),
                    _createElementVNode("button", {
                        onClick: _withModifiers(resetNewBadgeState, ["stop"]),
                        class: "close-button border-0 d-flex justify-content-center align-items-center position-absolute close-button"
                    }, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                        ]))])
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h6", _hoisted_4, _toDisplayString(badgeData.value?.name || 'Badge Name'), 1),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(badgeData.value?.description || "Badge Description"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("img", {
                            src: badgeData.value?.image
                        }, null, 8, _hoisted_7)
                    ])
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "position-absolute card-timer w-100" }, null, -1))
            ]));
        };
    }
});
